import React from "react";
import "../css/Footer.scss";

const Footer: React.FC = () => {
    return (
        <footer>
            Motivul &copy; 2024
        </footer>
    );
}

export default Footer;
